import "../styles/globals.css";
import "../styles/fonts.css";
import Head from "next/head";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import ErrorBoundary from "../components/ErrorBoundary";
import LogicalCanvas from '../components/LogicalCanvas';
import { HeaderContext } from '../contexts/headerContext';
import { shouldAnimatePageEntry } from '../utils/foundationShell';
import { resolveAppAuthorization } from '../utils/appAuthorization';


function MyApp({ Component, pageProps, router }) {
  const {
    authorizationParams,
    shouldRenderRoute,
  } = resolveAppAuthorization(router);
  const authorizationParames = authorizationParams || '';
  const isDev = process.env.NODE_ENV === "development";

  const [headerInfo, setHeaderInfo] = useState({ header: {} });

  useEffect(() => {
    const handleRouteChange = (url, { shallow }) => {
      console.log(
        `App is changing to ${url} ${shallow ? "with" : "without"
        } shallow routing`
      );
    };

    const handleRouteEnd = (url, { shallow }) => {

      // window.mTrack('pageview', { url: '/' + window.location.pathname.split('/')[1] });
      console.log(
        `App is ended to ${url} ${shallow ? "with" : "without"} shallow routing`
      );
    };
    router.events.on("routeChangeStart", handleRouteChange);
    router.events.on("routeChangeComplete", handleRouteEnd);

    return () => {
      router.events.off("routeChangeStart", handleRouteChange);
      router.events.off("routeChangeComplete", handleRouteEnd);
    };
  }, []);

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="viewport-fit=cover, width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
      </Head>
      <motion.div
        key={router.route}
        initial="pageInitial"
        animate="pageAnimate"
        variants={{
          pageInitial: {
            opacity: shouldAnimatePageEntry(router.route, router.query.transition) ? 0 : 1,
          },
          pageAnimate: {
            opacity: 1,
          },
        }}
      >
        {shouldRenderRoute && (
          <ErrorBoundary>
            {/* <HeaderContext.Provider value={{
              headerInfo,
              setHeaderInfo
            }}> */}
            <LogicalCanvas pathname={router.pathname}>
              <Component
                {...pageProps}
                authorizationParames={authorizationParames}
                baseUrl={isDev ? "" : "https://api.gymclassvr.com"}
                isDev={isDev}
              />
            </LogicalCanvas>
            {/* </HeaderContext.Provider>  */}
          </ErrorBoundary>
        )}
      </motion.div>
    </>
  );
}

export default MyApp;
